import { render, staticRenderFns } from "./ProductListAll.vue?vue&type=template&id=51416a15&scoped=true"
import script from "./ProductListAll.vue?vue&type=script&lang=js"
export * from "./ProductListAll.vue?vue&type=script&lang=js"
import style0 from "./ProductListAll.vue?vue&type=style&index=0&id=51416a15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51416a15",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ControllerLayeredNavigation: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerLayeredNavigation.js').default,ControllerProductList: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerProductList.js').default,ControllerFeaturedProducts: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerFeaturedProducts.js').default,ControllerProduct: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerProduct.js').default,ControllerProductListContainer: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerProductListContainer.js').default,ControllerNewsletter: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerNewsletter.js').default})
